'use strict';

exports.__esModule = true;
exports.BookHealthCheckModalActions = exports.SUBMIT_FORM = exports.VALIDATION_ERROR = exports.CLOSE_MODAL = exports.SET_PACKAGE_TYPE = exports.OPEN_MODAL = exports.VALIDATE_PROMO_CODE = exports.PROMO_CODE_CHANGE = exports.REASON_FOR_VISIT_CHANGE = exports.BIRTHDATE_YEAR_CHANGE = exports.BIRTHDATE_MONTH_CHANGE = exports.BIRTHDATE_DAY_CHANGE = exports.SEX_CHANGE = exports.PHONE_CHANGE = exports.EMAIL_CHANGE = exports.LAST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = undefined;

var _doctifyUtils = require('doctify-utils');

var FIRST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:FIRST_NAME_CHANGE'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var LAST_NAME_CHANGE = exports.LAST_NAME_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:LAST_NAME_CHANGE';
var EMAIL_CHANGE = exports.EMAIL_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:EMAIL_CHANGE';
var PHONE_CHANGE = exports.PHONE_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:PHONE_CHANGE';
var SEX_CHANGE = exports.SEX_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:SEX_CHANGE';
var BIRTHDATE_DAY_CHANGE = exports.BIRTHDATE_DAY_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:BIRTHDATE_DAY_CHANGE';
var BIRTHDATE_MONTH_CHANGE = exports.BIRTHDATE_MONTH_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:BIRTHDATE_MONTH_CHANGE';
var BIRTHDATE_YEAR_CHANGE = exports.BIRTHDATE_YEAR_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:BIRTHDATE_YEAR_CHANGE';
var REASON_FOR_VISIT_CHANGE = exports.REASON_FOR_VISIT_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:REASON_FOR_VISIT_CHANGE';
var PROMO_CODE_CHANGE = exports.PROMO_CODE_CHANGE = 'BOOK_HEALTH_CHECK_MODAL:PROMO_CODE_CHANGE';
var VALIDATE_PROMO_CODE = exports.VALIDATE_PROMO_CODE = 'BOOK_HEALTH_CHECK_MODAL:VALIDATE_PROMO_CODE';
var OPEN_MODAL = exports.OPEN_MODAL = 'BOOK_HEALTH_CHECK_MODAL:OPEN_MODAL';
var SET_PACKAGE_TYPE = exports.SET_PACKAGE_TYPE = 'BOOK_HEALTH_CHECK_MODAL:SET_PACKAGE_TYPE';
var CLOSE_MODAL = exports.CLOSE_MODAL = 'BOOK_HEALTH_CHECK_MODAL:CLOSE_MODAL';
var VALIDATION_ERROR = exports.VALIDATION_ERROR = 'BOOK_HEALTH_CHECK_MODAL:VALIDATION_ERROR';
var SUBMIT_FORM = exports.SUBMIT_FORM = 'BOOK_HEALTH_CHECK_MODAL:SUBMIT_FORM';

var BookHealthCheckModalActions = exports.BookHealthCheckModalActions = {
	onFirstNameChange: function onFirstNameChange(name) {
		return {
			type: FIRST_NAME_CHANGE,
			name: name
		};
	},
	onLastNameChange: function onLastNameChange(name) {
		return {
			type: LAST_NAME_CHANGE,
			name: name
		};
	},
	onEmailChange: function onEmailChange(email) {
		return {
			type: EMAIL_CHANGE,
			email: email
		};
	},
	onPhoneChange: function onPhoneChange(phone) {
		return {
			type: PHONE_CHANGE,
			phone: phone
		};
	},
	onGenderChange: function onGenderChange(gender) {
		return {
			type: SEX_CHANGE,
			gender: gender
		};
	},
	onBirthdateDayChange: function onBirthdateDayChange(day) {
		return {
			type: BIRTHDATE_DAY_CHANGE,
			day: day
		};
	},
	onBirthdateMonthChange: function onBirthdateMonthChange(month) {
		return {
			type: BIRTHDATE_MONTH_CHANGE,
			month: month
		};
	},
	onBirthdateYearChange: function onBirthdateYearChange(year) {
		return {
			type: BIRTHDATE_YEAR_CHANGE,
			year: year
		};
	},
	onReasonForVisitChange: function onReasonForVisitChange(reason) {
		return {
			type: REASON_FOR_VISIT_CHANGE,
			reason: reason
		};
	},
	onPromoCodeChange: function onPromoCodeChange(code) {
		return {
			type: PROMO_CODE_CHANGE,
			code: code
		};
	},
	onValidatePromoCode: function onValidatePromoCode(code, practiceId) {
		return (0, _doctifyUtils.createAction)({
			actionType: VALIDATE_PROMO_CODE,
			url: '/practices/' + practiceId + '/promotion_codes/' + code + '/validate',
			method: 'GET'
		});
	},
	openModal: function openModal(packageData, accountProfileData) {
		return {
			type: OPEN_MODAL,
			packageData: packageData,
			accountProfileData: accountProfileData
		};
	},
	setPackageType: function setPackageType(packageType) {
		return {
			type: SET_PACKAGE_TYPE,
			packageType: packageType
		};
	},
	closeModal: function closeModal() {
		return {
			type: CLOSE_MODAL
		};
	},
	validationError: function validationError() {
		return {
			type: VALIDATION_ERROR
		};
	},
	onSubmit: function onSubmit(requestData, practiceId) {
		return (0, _doctifyUtils.createAction)({
			actionType: SUBMIT_FORM,
			url: '/practices/' + practiceId + '/contact_request',
			method: 'POST',
			data: requestData
		});
	}
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/actions/book-health-check-modal.js